'use client';

type SwitchProps = {
  checked: boolean;
  onChange?: (e: MouseEvent) => void;
  disabled?: boolean;
};

/**
 * Switch component that allows toggling between two states.
 * @param checked - boolean to determine if the switch is checked
 * @param onChange - function to call when the switch is toggled
 * @param disabled - boolean to determine if the switch is disabled
 */
const Switch = ({ checked, onChange, disabled }: SwitchProps) => {
  return (
    <button
      onClick={(e) => onChange?.(e.nativeEvent)}
      disabled={disabled}
      className={`relative w-9.5 h-5 flex items-center rounded-full p-1 transition ${
        checked ? 'bg-red-600' : 'bg-gray-300'
      } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
    >
      <div
        className={`w-3.25 h-3.25 bg-white rounded-full shadow-md transform transition ${
          checked ? 'translate-x-4' : 'translate-x-0'
        }`}
      ></div>
    </button>
  );
};

export default Switch;
